import React from 'react';
import ReactDOM from 'react-dom';
import './style/index.scss';
import Routes from './config/router.config';

ReactDOM.render(<Routes />, document.getElementById('root'));
